const DATA_INTEGRATION_URL = process.env.API_URL + '/xugarhero/integration';
const GARMIN_TOKENS_URL = DATA_INTEGRATION_URL + '/garmin';

const dataIntegrationPost = (context, body) => {
  return new Promise((resolve, reject) => {
    context.$http.post(DATA_INTEGRATION_URL, body)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const getIntegratedPlatforms = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(DATA_INTEGRATION_URL)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getGarminTokens = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(GARMIN_TOKENS_URL)
      .then((response) => {
        resolve(response.bodyText);
      }, error => {
        reject(error);
      });
  });
};

const removeIntegration = (context, state) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(DATA_INTEGRATION_URL + '/' + state)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

export default {
  dataIntegrationPost,
  getIntegratedPlatforms,
  getGarminTokens,
  removeIntegration
};



// WEBPACK FOOTER //
// ./src/brand/health/api/integration/index.js